import { getSysEntInfo, getThemeData } from '@/api/theme'
import { getLocalStorage, setLocalStorage } from '@/utils/cache'
const state = () => ({
  sysEntInfo: getLocalStorage('sysEntInfo')
    ? JSON.parse(getLocalStorage('sysEntInfo'))
    : {},
  themeData: getLocalStorage('themeData')
    ? JSON.parse(getLocalStorage('themeData'))
    : null,
  themeInfo: getLocalStorage('themeInfo')
    ? JSON.parse(getLocalStorage('themeInfo'))
    : {
      theme: 'v0',
    },
})

const mutations = {
  SET_SYSENTINFO: (state, sysEntInfo) => {
    
    state.sysEntInfo = sysEntInfo
    setLocalStorage('sysEntInfo', JSON.stringify(sysEntInfo))
  },
  SET_THEMEDATA: (state, themeData) => {
    
    state.themeData = themeData
    setLocalStorage('themeData', JSON.stringify(themeData))
    // console.log('看看mutations的themeData',getLocalStorage('themeData'));
  },
  SET_THEMEINFO: (state, themeInfo) => {
    state.themeInfo = themeInfo
    setLocalStorage('themeInfo', JSON.stringify(themeInfo))
  },
}
const actions = {
  // 获取用户信息
  getSysEntInfo({ commit, state }, params) {
    
    return new Promise((resolve, reject) => {
      getSysEntInfo(params)
        .then((response) => {
          
          const { data } = response
          let sysEntInfo = Object.assign({}, data)
          // console.log(111, sysEntInfo);
          commit('SET_SYSENTINFO', sysEntInfo)
          resolve(data)
        })
        .catch((err) => {
          // console.log('sysEntInfo-err', err)
          resolve()
        })
    })
  },
  // 获取风格设置的首页轮播图和登录页背景图
  getThemeData({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      getThemeData(params)
        .then((response) => {
          
          // console.log('kankan这个data',data);
          const { data } = response
          let themeData = Object.assign({}, data)
          commit('SET_THEMEDATA', themeData)
          resolve(data)
        })
        .catch((err) => {
          // console.log('themeData-err', err)
          resolve()
        })
    })
  },
}
const getters = {
  sysEntInfo: (state) => state.sysEntInfo,
  themeData: (state) => state.themeData,
  themeInfo: (state) => state.themeInfo,
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/module/theme.js